import { useContext } from 'react';
import { CardContent, Typography, Grid, TextField as MuiTextField } from '@material-ui/core';
import { Field, useFormikContext } from 'formik';
import { TextField } from 'formik-material-ui';
import { applicationContext } from 'helpers/services';
import { Autocomplete } from 'formik-material-ui-lab';
import { dealerSchema } from '../Dealer';
import * as yup from 'yup';


let Address = () => {
    let appService = useContext(applicationContext);

    type Dealer = yup.InferType<typeof dealerSchema>;
    let form = useFormikContext<Dealer>();

    return (
        <CardContent>
            <Typography variant="h4">Address</Typography>
            <Field
                label="Street"
                name="address"
                component={TextField}
                fullWidth
                margin="normal"
            />
            <Grid container spacing={1} alignItems="flex-end">
                <Grid item xs={3}>
                    <Field
                        label="Zip code"
                        name="zipCode"
                        component={TextField}
                        fullWidth
                        margin="normal"
                    />
                </Grid>
                <Grid item xs>
                    <Field
                        label="City"
                        name="city"
                        component={TextField}
                        fullWidth
                        margin="normal"
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1} alignItems="flex-end">
                <Grid item xs={3}>
                    <Field
                        label="State/Province"
                        name="countyCode"
                        component={TextField}
                        fullWidth
                        margin="normal"
                    />
                </Grid>
                <Grid item xs>
                    <Field
                        label="Description"
                        name="countyDesc"
                        component={TextField}
                        fullWidth
                        margin="normal"
                    />
                </Grid>
            </Grid>
            <Field
                name="country"
                component={Autocomplete}
                options={appService.referenceData.availableCountries.map(x => x.key)}
                getOptionSelected={(option: string, value: string) => option === value}
                getOptionLabel={(option: string) => appService.referenceData.availableCountries.getValueByKey(option)}
                renderInput={(params: any) =>
                    <MuiTextField
                        {...params}
                        size="small"
                        margin="normal"
                        error={form.touched['country'] && !!form.errors['country']}
                        helperText={form.errors['country']}
                        label="Countries"
                    />
                }
            />
            <Grid container spacing={2}>
                <Grid item xs>
                    <Field
                        label="Latitude"
                        name="lat"
                        component={TextField}
                        fullWidth
                        margin="normal"
                    />
                </Grid>
                <Grid item xs>
                    <Field
                        label="Longitude"
                        name="lng"
                        component={TextField}
                        fullWidth
                        margin="normal"
                    />
                </Grid>
            </Grid>
        </CardContent>
    )
}


export default Address;